// extracted by mini-css-extract-plugin
export default {"childrenRow":"Category_childrenRow__Mun+n","categoryName":"Category_categoryName__AbDaC"};